/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Schoolname_Otto_Hahn_Schule_Hanau5Inputs */

const en__field__enum_schoolname_otto_hahn_schule_hanau5 = /** @type {(inputs: _Field__Enum_Schoolname_Otto_Hahn_Schule_Hanau5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hanau`)
};

const de__field__enum_schoolname_otto_hahn_schule_hanau5 = /** @type {(inputs: _Field__Enum_Schoolname_Otto_Hahn_Schule_Hanau5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otto-Hahn-Schule`)
};

/**
* | output |
* | --- |
* | "Hanau" |
*
* @param {_Field__Enum_Schoolname_Otto_Hahn_Schule_Hanau5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_schoolname_otto_hahn_schule_hanau5 = /** @type {((inputs?: _Field__Enum_Schoolname_Otto_Hahn_Schule_Hanau5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Schoolname_Otto_Hahn_Schule_Hanau5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_schoolname_otto_hahn_schule_hanau5(inputs)
	return de__field__enum_schoolname_otto_hahn_schule_hanau5(inputs)
});
export { _field__enum_schoolname_otto_hahn_schule_hanau5 as "_field__enum_schoolName_Otto_Hahn_Schule_Hanau" }